export default "dist/images/components-columns-width-control-3-4-grid.c3e518b.png";